// extracted by mini-css-extract-plugin
export default {"icon":"FormItem_icon__9M7ie","title":"FormItem_title__qngFt","text":"FormItem_text__y5FIR","FormItem":"FormItem_FormItem__0lRak"};